/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EmailSignatureCreateSignatureKind } from './emailSignatureCreateSignatureKind';
import type { EmailSignatureCreateTemplateKey } from './emailSignatureCreateTemplateKey';
import type { SignatureTemplateConfig } from './signatureTemplateConfig';

/**
 * Create a brand-new signature row in draft status (``saved_at`` NULL).
 *
 * Initial content is optional so the FE can open the editor immediately
 * and PATCH content as the user types. Publishing (``POST .../publish``)
 * is what gates on a non-empty name/body.
 */
export interface EmailSignatureCreate {
  /** @maxLength 120 */
  name?: string;
  /** @maxLength 200000 */
  body_html?: string;
  signature_kind?: EmailSignatureCreateSignatureKind;
  template_key?: EmailSignatureCreateTemplateKey;
  template_config?: SignatureTemplateConfig | null;
}
